'use strict';

module.exports = {
    'lang': 'zh-cn',
    'ok': '确定',
    'cancel': '取消',

    'en-us': {
        'ok': 'ok',
        'cancel': 'cancel'
    }
};